import { requestHandler } from "../Store";

export const getUserProfile = (token, user_id) => {
  return requestHandler({
    method: "GET",
    url: `users/${user_id}/profile`,
    token,
  });
};

export const deleteUserProfile = (token, user_id, data) => {
  return requestHandler({
    method: "PUT",
    url: `users/${user_id}/deleteUser`,
    token,
    data,
  });
};
export const updateUserProfile = (token, user_id, data) => {
  return requestHandler({
    method: "PUT",
    url: `users/${user_id}/profile`,
    token,
    data,
  });
};

export const userOnBoarding = (token, user_id, data) => {
  return requestHandler({
    method: "POST",
    url: `users/${user_id}/onboarding`,
    token,
    data,
  });
};
